import { render } from "./SeventhComponent.vue?vue&type=template&id=24f94e50&scoped=true"
import script from "./SeventhComponent.vue?vue&type=script&lang=js"
export * from "./SeventhComponent.vue?vue&type=script&lang=js"

import "./SeventhComponent.vue?vue&type=style&index=0&id=24f94e50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f94e50"]])

export default __exports__